<script>
  import LightBox from '../../assets/general/ImageLightBox.svelte';
  import Button from '../../assets/general/button.svelte';

  export let alignment;
  export let bookTitle;
  export let description;
  export let coverIMG;
  export let purchaseLink;

  // We can use a reactive statement to handle changes in window size for responsiveness
  let isMobile = false;
  
  // Function to update isMobile based on window width
  function handleResize() {
    isMobile = window.innerWidth <= 768; // You can adjust the breakpoint as needed
  }

  // Add event listener for resize
  window.addEventListener('resize', handleResize);
  // Initialize the state
  handleResize();
</script>

<style>
  h1 {
  font-family: 'Oswald';
  padding: 1rem;
  }
.book-container {
  display: flex;
  flex-direction: row;
  align-items: center; /* This will vertically center the children */
  /* Add a min-height if necessary */
  min-height: 400px; /* Adjust as per your design */
}

  .left-aligned {
    justify-content: flex-start;
  }

  .right-aligned {
    justify-content: flex-end;
  }

  .book-image, .purchase-link {
    text-align: center;
  }

  .description {
    flex-grow: 1;
  }

  /* Mobile styles */
  @media (max-width: 768px) {
    .book-container {
      flex-direction: column;
      align-items: center;
    }

    .description, .book-image, .purchase-link {
      text-align: center;
    }
  }
</style>

  {#if !isMobile}
    <h1>{bookTitle}</h1>
  {/if}
<div class="book-container {alignment === 'left' ? 'left-aligned' : 'right-aligned'}">
  {#if !isMobile}
    {#if alignment === 'left'}
      <div class="book-image">
        <LightBox
          imageUrl="{coverIMG}"
          altText="{bookTitle} Book Cover"
          imageWidth="auto"
          imageHeight="343px"
          title="{bookTitle}"
          />
          <br><br>
        <Button
          text="PURCHASE {bookTitle}"
          link="{purchaseLink}"
        />
      </div>
      <div class="description">{@html description}</div>
    {:else}
      <div class="description">{@html description}</div>
      <div class="book-image">
        <LightBox
          imageUrl="{coverIMG}"
          altText="{bookTitle} Book Cover"
          imageWidth="auto"
          imageHeight="343px"
          title="{bookTitle}"
          />
          <br><br>
        <Button
          text="PURCHASE {bookTitle}"
          link="{purchaseLink}"
        />
      </div>
    {/if}
  {:else}
    <div class="book-image" style="margin-top: 1rem;">
      <LightBox
        imageUrl="{coverIMG}"
        altText="{bookTitle} Book Cover"
        imageWidth="77%"
        imageHeight="auto"
        title="{bookTitle}" 
      />
    </div>
    <h1>{bookTitle}</h1>
    <div class="description">{@html description}</div>
    <div class="purchase-link" style="margin-top: 1rem;">
      <Button
        text="PURCHASE {bookTitle}"
        link="{purchaseLink}"
      />
    </div>
  {/if}
</div>
